export default __webpack_public_path__ + "static/media/DNo.5-2.6e8296dc.jpg";